import React from "react";
import { MCheckbox, MLabel, MSelect, ValidatedForm } from "components/forms";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Col,
  Row,
} from "design-react-kit";
import {
  dateHelper,
  enrollmentAdminService,
  enrollmentService,
  networkErrorHelper,
  payloadBuilder,
} from "libs";
import ReactHtmlParser from "react-html-parser";
import { DichiarazioniUlteriori, FormTitleA, FormTitleAConfigurator, FormTitleL2 } from "./enroll30CFU";
import { ENROLLMENT_STEPS } from "const";
import { FormTitleStep1 } from "./enroll60CFU";
import { FormTitleStep1270 } from "./enroll60CFU/FormTitleStep1270";
import { FormRef2TitleStep1 } from "./enroll60CFU/FormRef2TitleStep1";
import { FormTitleITPStep1 } from "./enroll60CFU/FormTitleITPStep1";
import { DichiarazioneTitoloEstero } from "./enroll60CFU/DichiarazioneTitoloEstero";
import { FormTitleITSStep1 } from "./enroll60CFU/FormTitleITSStep1";

export class EnrollFillForm30CFUArt13 extends ValidatedForm {
  emptyFields = {
    examSite: 0,
  };

  PAYLOADS = {
    titleCheckBoxList: [],
    examSites: [],
    titleSelect: [],
  };

  FIELDS_GROUP = [
    [
      {
        field: "preferExamPresence",
        label: "1. SEDE ESAMI",
        infoText:
          "Seleziona una sede convenzionata o in fase di accreditamento",
        component: MLabel,
        className: "col-md-6 pt-3",
      },
    ],
    [
      {
        field: "examSite",
        payload: { options: this.PAYLOADS.examSites },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        field: "preferExamPresence",
        label: "2. REQUISITO DI ACCESSO",
        infoText:
          "(Riservato per coloro che sono già in possesso di abilitazione su una classe di concorso o su un altro grado di istruzione nonché per coloro che sono in possesso della specializzazione sul sostegno, che conseguono l'abilitazione in altre classi di concorso o in altri gradi di istruzione fermo restando il possesso del titolo di studio necessario con riferimento alla classe di concorso.):",
        component: MLabel,
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        field: "titleSelect",
        payload: { options: this.PAYLOADS.titleSelect },
        component: MSelect,
        onChange: (_, value) => this.onChangeTitleA(_, value),
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {
    examSite: "Specificare una sede esami",
    titleSelect: "Specificare un requisito di accesso",
  };

  validation = {
    examSite: (value) => value > "",
    titleSelect: (value) => value > "",
  };

  constructor(props) {
    super(props);
    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);        
  }

  defaultState = {
    collapseOpenLAU_VO: false,
    collapseOpenLAU_270: false,
    collapseOpenLAU_02_509: false,
    collapseOpenLAU_CU_509: false,
    collapseOpenAFAM_II_24: false,
    collapseOpenITP: false,
    collapseOpenITS: false,
    collapseOpenTITNONABILIT__EST: false,
  };

  state = {
    _formRefTitleA: null,
    _formRefTitleL2: null,
    _formRefTitle3: [],
    _formRefTitle3_s: null,
    _formRefOther: null,
    loading: true,
    ...this.emptyFields,
    ...this.defaultState,
    defaultValues: {
      ...this.emptyFields,
    },
    titleA: "",
    validationSummary: "",
    competitionClass: this.props.enrollData.pluginConfig.competitionClass.replace("_2_", ""),
    titleStep3Active: [],
  };

  toggle = (id) => {
    this.setState({
      ...this.defaultState,
      [`collapseOpen${id}`]: !this.state[`collapseOpen${id}`],
    });
  };

  onSubmit = async () => {
    this.payload = payloadBuilder(this.state);
    let qualifications = [];
    let validationList = [];

    let isValid = false;
    let isValidTitleA = true;
    let isValidTitleL2 = true;
    let isValidTitle3 = true;
    let isValidOther = true;

    const { _formRefTitleA, _formRefOther, _formRefTitle3, _formRefTitle3_s, _formRefTitleL2 } = this.state;

    const currentForms = Object.values(_formRefTitle3).filter(
      (item) => item.current !== null
    );

    if (currentForms.length === 0) {
      validationList.push(
        "TITOLO DI ACCESSO: Specificare il Titolo di Accesso"
      );
      isValidTitle3 = false;
    } else {
      const currentForm = currentForms[0];

      const checkValidation = currentForm.current.onSubmit();

      if (checkValidation === true) {
        const payload = currentForm.current.getPayload();

        // verify if the payload is an array or an object
        if (Array.isArray(payload)) {
          qualifications.push(...payload);
        } else {
          qualifications.push(payload);
        }
        isValidTitle3 = true;
      } else {
        validationList.push(
          "TITOLO DI ACCESSO " +
          currentForm.current.getFormLabel() +
          " : Compilare tutti i campi obbligatori."
        );
        isValidTitle3 = false;
      }
    }

    let isValidTitle3s = true;

    if (_formRefTitle3_s && _formRefTitle3_s.current) {
      const checkValidation3s = _formRefTitle3_s.current.checkValidation();

      if (checkValidation3s === true) {
        const payload3s = _formRefTitle3_s.current.getPayload();
        qualifications.push(payload3s);
      } else {
        validationList.push(
          "TITOLO TRIENNALE: Compilare tutti i campi obbligatori."
        );
        isValidTitle3s = false;
      }
    }

    isValidTitle3 = isValidTitle3 && isValidTitle3s;

    let isValidForm = this.checkValidation();
    if (!isValidForm) {
      validationList.push("Inserire i campi obbligatori in rosso");
    }

    // validate FormTitleA
    if (_formRefTitleA && _formRefTitleA.current != null) {
      isValidTitleA = _formRefTitleA.current.onSubmit();

      // get payload
      const payloadTitleA = _formRefTitleA.current.getPayload();

      if (isValidTitleA) {
        payloadTitleA.qualificationCode = "titleA";
        qualifications.push(payloadTitleA);
      } else {
        validationList.push(
          "Requisito di accesso seguente con dati mancanti <b>" +
          payloadTitleA.qualificationType +
          "</b>"
        );
      }
    } else {
      isValidTitleA = false;
      validationList.push("Errore nell'inserimento del requisito di accesso");
    }

    //validate formTitleL2
    if (this.state.competitionClass === "A023") {
      if (_formRefTitleL2 && _formRefTitleL2.current != null) {
        isValidTitleL2 = _formRefTitleL2.current.onSubmit();
        if (isValidTitleL2) {
          const payloadTitleL2 = _formRefTitleL2.current.getPayload();
          qualifications.push(payloadTitleL2);
        } else {
          validationList.push("TITOLO SPECIALIZZAZIONE L2: Compilare tutti i campi obbligatori.");
        }
      } else {
        isValidTitleL2 = false;
        validationList.push("Errore imprevisto nell'inserimento del titolo di specializzazione L2.");
      }
    }

    //  validate formOther
    if (_formRefOther && _formRefOther.current != null) {
      isValidOther = _formRefOther.current.onSubmit();
      if (isValidOther) {
        // get payload
        const payloadOther = _formRefOther.current.getPayload();
        qualifications.push(...payloadOther);
      } else {
        validationList.push(
          "PUNTO 4. Ulteriori dichiarazioni con dati mancanti"
        );
      }
    } else {
      isValidOther = false;
      validationList.push("Errore imprevisto nelle dichiarazioni");
    }

    // if valid call saveRemote: send data to server
    isValid = isValidTitleA && isValidTitleL2 && isValidTitle3 && isValidOther && isValidForm;

    if (isValid) {
      const payloadQualification = {
        idEnrollment: this.props.enrollData.idEnrollment,
        qualifications: qualifications,
        currentStep: ENROLLMENT_STEPS.FILL,
      };

      try {
        await enrollmentService.updateEnrollmentQualification(
          payloadQualification
        );
      } catch (errors) {
        validationList.push(
          "Errore imprevisto nell'invio dei dati. Se il problema persiste contattare il supporto tecnico."
        );
        networkErrorHelper.notify(errors);
        isValid = false;
      }
    }

    // set state with validation summary
    let validationSummary = "";
    if (validationList.length > 0) {
      validationSummary =
        "<ul><li>" + validationList.join("</li><li>") + "</li></ul>";
    }

    this.setState({ validationSummary: validationSummary });

    return isValid;
  };

  getPayload = () => {
    return this.payload;
  };

  getDefaultPayload = (qualifications) => {
    const defaultPayloads = {
      titleA: [],
      SpecializzazioneL2: [],
      LAU_VO: [],
      LAU_270: [],
      LAU_02_270: [],
      LAU_CU_270: [],
      LAU_02_509: [],
      LAU_CU_509: [],
      AFAM_II_24: [],
      ITP: [],
      ITS: [],
      TITNONABILIT__EST: [],
      LaureaTriennale: [],
      CLaurea: [],
      CDiploma: [],
      CCFU: [],
      InsegnamentoMultiManager: [],
    };

    qualifications.forEach((q) => {
      //if title A sort by qualificationCode
      if (q.qualificationCode === "titleA") {
        defaultPayloads.titleA.push(q);
        return;
      }

      const template = q.template;

      if (!defaultPayloads[template]) {
        defaultPayloads[template] = [];
      }

      defaultPayloads[template].push(q);
    });

    // merge LAU_02_270 e LAU_CU_270 in LAU_270
    const lau270 =
      defaultPayloads.LAU_02_270[0] || defaultPayloads.LAU_CU_270[0] || null;
    defaultPayloads.LAU_270 = lau270 ? [lau270] : [];

    return defaultPayloads;
  };

  loadRemote(additionalState = {}) {
    const { idExamSession, idEnrollment, registrationCode } =
      this.props.enrollData;
    const { competitionClass } = this.state;

    if (this.PAYLOADS.titleSelect.length < 1) {
      // load payloads to fill the select options
      this.PAYLOADS.titleSelect.unshift({
        label: "SELEZIONARE UN REQUISITO DI ACCESSO",
        value: "",
      });
    }

    FormTitleAConfigurator.forms.forEach((item) => {
      this.PAYLOADS.titleSelect.push({
        label: item.label,
        value: item.template,
      });
    });

    this.setState({
      titleSelect: { options: this.PAYLOADS.titleSelect },
    });

    if (this.PAYLOADS.examSites.length < 1) {
      // load payloads to fill the select options
      enrollmentAdminService
        .myExamSites(idExamSession, registrationCode)
        .then(({ data }) => {
          const { payload } = data;
          const sites = payload.map(({ value }) => ({
            label: value,
            value: value,
          }));

          this.PAYLOADS.examSites.unshift({ label: "Seleziona", value: "" });
          this.PAYLOADS.examSites.push(...sites);

          //set default examSite
          this.setState((prevState) => ({
            examSites: { options: this.PAYLOADS.examSites },
            defaultValues: {
              ...prevState.defaultValues,
              examSite: this.props.enrollData.examSite || "",
            },
          }));
        })
        .catch((errors) => {
          console.log(errors);
          networkErrorHelper.notify(errors);
        });
    }

    /** get all remote qualificationTitleEntry by competitionClass */
    enrollmentService
      .getQualificationTitleEntry(competitionClass)
      .then(({ data }) => {
        const tmpArr = data.payload.titles;
        const payloadCurrentTitles = [];
        const payloadLaureandoTitles = [];

        for (let i = 0; i < tmpArr.length; i++) {
          let tmpTitle = tmpArr[i].title;
          let hasEnd = false;

          if (tmpArr[i].achievementDateStart !== null) {
            tmpTitle +=
              " - conseguita dopo il " +
              dateHelper.toITDate(tmpArr[i].achievementDateStart);
          }
          if (tmpArr[i].achievementDateEnd !== null) {
            hasEnd = true;
            tmpTitle +=
              " - conseguita entro il " +
              dateHelper.toITDate(tmpArr[i].achievementDateEnd);
          }
          if (tmpArr[i].aaStart !== null) {
            tmpTitle +=
              " - conseguita a partire dall'anno Accademico " +
              tmpArr[i].aaStart;
          }
          if (tmpArr[i].aaEnd !== null) {
            hasEnd = true;
            tmpTitle +=
              " - conseguita entro l'anno Accademico " + tmpArr[i].aaEnd;
          }

          if (!hasEnd) {
            payloadCurrentTitles.push({
              value: tmpArr[i].title,
              label: tmpArr[i].title,
            });

            if (
              tmpArr[i].extCode === "LAU_02_270" ||
              tmpArr[i].extCode === "LAU_CU_270"
            ) {
              payloadLaureandoTitles.push({
                value: tmpArr[i].title,
                label: tmpArr[i].title,
              });
            }
          }

          this.PAYLOADS.titleCheckBoxList.push({
            qualificationType: tmpArr[i].title,
            label: tmpTitle,
            value: tmpArr[i].id,
            achievementDateStart: tmpArr[i].achievementDateStart,
            achievementDateEnd: tmpArr[i].achievementDateEnd,
            aaStart: tmpArr[i].aaStart,
            aaEnd: tmpArr[i].aaEnd,
            extCode: tmpArr[i].extCode,
            note: tmpArr[i].note,
            code: tmpArr[i].code,
          });
        }

        // Prepare refs to form dynamically
        const formRefTitle = [];
        this.PAYLOADS.titleCheckBoxList.forEach((item) => {
          formRefTitle[item.value.toString()] = React.createRef();
        });

        formRefTitle["TITNONABILIT__EST"] = React.createRef();

        const newState = {
          loading: false,
          ...additionalState,
          _formRefTitleA: React.createRef(),
          _formRefOther: React.createRef(),
          _formRefTitle3: formRefTitle,
          _formRefTitle3_s: React.createRef(),
          _formRefTitleL2: React.createRef(),
          titleCheckBoxList: { options: this.PAYLOADS.titleCheckBoxList },
          payloadCurrentTitles,
        };

        this.setState(newState);

        this.loadRemoteQualifications(idEnrollment);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  }

  loadRemoteQualifications = (idEnrollment) => {
    enrollmentService
      .getEnrollmentQualifications(idEnrollment)
      .then(({ data }) => {
        const qualifications = data.payload?.qualifications || [];
        const defaultPayloads = this.getDefaultPayload(qualifications);

        //open defaultPayload accordion
        const accordionState = {
          collapseOpenLAU_VO: !!defaultPayloads.LAU_VO?.length,
          collapseOpenLAU_270: !!(
            defaultPayloads.LAU_02_270?.length ||
            defaultPayloads.LAU_CU_270?.length
          ),
          collapseOpenLAU_02_509: !!defaultPayloads.LAU_02_509?.length,
          collapseOpenLAU_CU_509: !!defaultPayloads.LAU_CU_509?.length,
          collapseOpenAFAM_II_24: !!defaultPayloads.AFAM_II_24?.length,
          collapseOpenITP: !!defaultPayloads.ITP?.length,
          collapseOpenITS: !!defaultPayloads.ITS?.length,
          collapseOpenTITNONABILIT__EST:
            !!defaultPayloads.TITNONABILIT__EST?.length,
        };

        //activate defaultPayload checkbox (only one)
        const titleStep3Active = [];

        Object.keys(defaultPayloads).forEach((accordionKey) => {
          const payloadList = defaultPayloads[accordionKey] || [];

          payloadList.forEach((q) => {
            if (q.qteId) {
              titleStep3Active.push(q.qteId.toString());
            }
          });
        });

        this.setState({
          defaultValues: { ...this.state.defaultValues, ...defaultPayloads },
          ...accordionState,
          titleStep3Active,
          loading: false,
        });

        //set default titleA
        if (defaultPayloads.titleA && defaultPayloads.titleA.length > 0) {
          const titleA = defaultPayloads.titleA[0];
          const template = titleA.template;

          this.setState({
            titleSelect: {
              value: template,
              isValid: true,
              message: "Specificare un requisito di accesso",
            },
            titleA: template,
          });
        }
      })
      .catch((errors) => {
        this.setState({ loading: false });
        console.error(errors);
        networkErrorHelper.notify(errors);
      });
  };

  onChangeTitleA = (id, value) => {
    this.setState({ titleA: value });
  };

  onChangeStep3Active = (id, value) => {
    const { titleStep3Active } = this.state;
    titleStep3Active.length = 0;

    document.querySelectorAll('input[type="checkbox"]').forEach((el) => {
      if (el.id !== id) {
        el.checked = false;
      }
    });

    this.setState({ selectedCheckbox: null });

    if (value) {
      if (!titleStep3Active.includes(id)) {
        if (titleStep3Active.length === 0) {
          this.setState({ globalCheckDisable: true });
        }
        titleStep3Active.push(id);
        this.setState({ selectedCheckbox: id });
      }
    } else {
      const index = titleStep3Active.indexOf(id);
      if (index > -1) {
        titleStep3Active.splice(index, 1);
        this.setState({
          globalCheckDisable: false,
          selectedCheckbox: null,
        });
      }
    }

    this.setState({ titleStep3Active: titleStep3Active });
  };

  render() {
    const { loading, defaultValues, _formRefTitleA, _formRefTitle3, _formRefTitle3_s, _formRefOther, _formRefTitleL2, validationSummary } =
      this.state;

    if (loading) return <></>;

    // filter the this.PAYLOADS.titleCheckBoxList to show only the item with extCode=LAU_02
    const titles_LAU_VO = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "LAU_VO"
    );
    const titles_LAU_270 = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "LAU_02_270" || item.extCode === "LAU_CU_270"
    );
    const titles_LAU_02_509 = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "LAU_02_509"
    );
    const titles_LAU_CU_509 = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "LAU_CU_509"
    );
    const titles_AFAM_II_24 = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "AFAM_II_24"
    );
    const titles_ITP = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "ITP"
    );
    const titles_ITS = this.PAYLOADS.titleCheckBoxList.filter(
      (item) => item.extCode === "ITS"
    );

    const {
      collapseOpenAFAM_II_24,
      collapseOpenITP,
      collapseOpenITS,
      collapseOpenLAU_VO,
      collapseOpenLAU_270,
      collapseOpenLAU_02_509,
      collapseOpenLAU_CU_509,
      collapseOpenTITNONABILIT__EST,
      competitionClass,
    } = this.state;

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);
    const isDiplomaClass = competitionClass.startsWith("B0");
  

    return (
      <>
        <div>
          <form>{code}</form>
        </div>
        <Row>
          <Col>
            {(FormTitleAConfigurator.forms || [])
              .filter((item) => {
                return item.template === this.state.titleA;
              })
              .map((item, idx) => {
                //const Component = item.form;

                return (
                  <div key={`ctitleA=${item.template}`}>
                    <p>
                      <b>{item.label}:</b> inserisci i dati
                    </p>
                    <FormTitleA
                      key={`ftitleA=${item.template}`}
                      qualificationType={item.label}
                      template={item.template}
                      ref={_formRefTitleA}
                      defaultPayload={defaultValues.titleA}
                    />
                  </div>
                );
              })}
          </Col>
        </Row>        

        <hr />
        <Row>
          <Col>
            <h6>3. TITOLO DI STUDIO</h6>
            <Accordion>
              {titles_LAU_VO.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenLAU_VO}
                    onToggle={() => this.toggle("LAU_VO")}
                  >
                    <h5>LAUREA VECCHIO ORDINAMENTO</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenLAU_VO}>
                    {titles_LAU_VO.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b> {item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <div className="m-4 p-3 border border-secondary rounded-lg">
                                <FormTitleStep1
                                  key={`titleStep1=${item.value.toString()}`}
                                  qualificationType={item.qualificationType}
                                  extCode={item.extCode}
                                  item={item}
                                  ref={_formRefTitle3[item.value.toString()]}
                                  idx={idx}
                                  defaultPayload={defaultValues.LAU_VO[0]}
                                />
                              </div>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {titles_LAU_270.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenLAU_270}
                    onToggle={() => this.toggle("LAU_270")}
                  >
                    <h5>LAUREA MAGISTRALE</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenLAU_270}>
                    {titles_LAU_270.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b>{item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <>
                                <div className="m-4 p-3 border border-secondary rounded-lg">
                                  <FormTitleStep1270
                                    key={`titleStep1=${item.value.toString()}`}
                                    qualificationType={item.qualificationType}
                                    item={item}
                                    ref={_formRefTitle3[item.value.toString()]}
                                    idx={idx}
                                    defaultPayload={{
                                      laureaMagistrale: defaultValues.LAU_270[0],
                                      laureaTriennale:
                                        defaultValues.LaureaTriennale[0],
                                    }}
                                  />
                                </div>
                              </>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {titles_LAU_02_509.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenLAU_02_509}
                    onToggle={() => this.toggle("LAU_02_509")}
                  >
                    <h5>LAUREA SPECIALISTICA BIENNALE</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenLAU_02_509}>
                    {titles_LAU_02_509.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b>{item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <>
                                <div className="m-4 p-3 border border-secondary rounded-lg">
                                  <FormTitleStep1
                                    key={`titleStep1=${item.value.toString()}`}
                                    qualificationType={item.qualificationType}
                                    extCode={item.extCode}
                                    item={item}
                                    ref={_formRefTitle3[item.value.toString()]}
                                    idx={idx}
                                    defaultPayload={defaultValues.LAU_02_509[0]}
                                  />
                                </div>

                                <div className="m-4 p-3 border border-secondary rounded-lg">
                                  <h4>
                                    Informazioni sulla tua laurea triennale:
                                  </h4>
                                  <FormRef2TitleStep1
                                    key={`titleRef2Step1=${item.value.toString()}`}
                                    ref={_formRefTitle3_s}
                                    idx={idx}
                                    defaultPayload={
                                      defaultValues.LaureaTriennale[0]
                                    }
                                  />
                                </div>
                              </>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {titles_LAU_CU_509.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenLAU_CU_509}
                    onToggle={() => this.toggle("LAU_CU_509")}
                  >
                    <h5>LAUREA SPECIALISTICA A CICLO UNICO</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenLAU_CU_509}>
                    {titles_LAU_CU_509.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b>{item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <>
                                <div className="m-4 p-3 border border-secondary rounded-lg">
                                  <FormTitleStep1
                                    key={`titleStep1=${item.value.toString()}`}
                                    qualificationType={item.qualificationType}
                                    extCode={item.extCode}
                                    item={item}
                                    ref={_formRefTitle3[item.value.toString()]}
                                    idx={idx}
                                    defaultPayload={defaultValues.LAU_CU_509[0]}
                                  />
                                </div>
                              </>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {titles_AFAM_II_24.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenAFAM_II_24}
                    onToggle={() => this.toggle("AFAM_II_24")}
                  >
                    <h5>TITOLI AFAM</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenAFAM_II_24}>
                    {titles_AFAM_II_24.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b>{item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <div className="m-4 p-3 border border-secondary rounded-lg">
                                <FormTitleStep1
                                  key={`titleStep1=${item.value.toString()}`}
                                  qualificationType={item.qualificationType}
                                  extCode={item.extCode}
                                  item={item}
                                  ref={_formRefTitle3[item.value.toString()]}
                                  idx={idx}
                                  defaultPayload={defaultValues.AFAM_II_24[0]}
                                />
                              </div>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {titles_ITP.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenITP}
                    onToggle={() => this.toggle("ITP")}
                  >
                    <h5>DIPLOMA</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenITP}>
                    {titles_ITP.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b>{item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <div className="m-4 p-3 border border-secondary rounded-lg">
                                <FormTitleITPStep1
                                  key={`titleStep1=${item.value.toString()}`}
                                  qualificationType={item.qualificationType}
                                  extCode={item.extCode}
                                  item={item}
                                  ref={_formRefTitle3[item.value.toString()]}
                                  idx={idx}
                                  defaultPayload={defaultValues.ITP[0]}
                                />
                              </div>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {titles_ITS.length > 0 && (
                <>
                  <AccordionHeader
                    active={collapseOpenITS}
                    onToggle={() => this.toggle("ITS")}
                  >
                    <h5>
                      DIPLOMA ISTITUTO TECNOLOGICO SUPERIORE (ITS ACADEMY)
                    </h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenITS}>
                    {titles_ITS.map((item, idx) => {
                      return (
                        <div key={`titleStep1=${item.value.toString()}`}>
                          <MCheckbox
                            onChange={this.onChangeStep3Active}
                            id={item.value.toString()}
                            name={item.value.toString()}
                            readOnly={false}
                            value={this.state.titleStep3Active.includes(
                              item.value.toString()
                            )}
                          >
                            <p>
                              <b> {item.label}</b>
                            </p>
                          </MCheckbox>
                          {this.state.titleStep3Active.includes(
                            item.value.toString()
                          ) && (
                              <div className="m-4 p-3 border border-secondary rounded-lg">
                                <FormTitleITSStep1
                                  key={`titleStep1=${item.value.toString()}`}
                                  qualificationType={item.qualificationType}
                                  extCode={item.extCode}
                                  item={item}
                                 ref={_formRefTitle3[item.value.toString()]}
                                  idx={idx}
                                  defaultPayload={defaultValues.ITS[0]}
                                />
                              </div>
                            )}
                        </div>
                      );
                    })}
                  </AccordionBody>
                </>
              )}
              {!isDiplomaClass && (
                <>
                  <AccordionHeader
                    active={collapseOpenTITNONABILIT__EST}
                    onToggle={() => this.toggle("TITNONABILIT__EST")}
                  >
                    <h5>TITOLO ESTERO</h5>
                  </AccordionHeader>
                  <AccordionBody active={collapseOpenTITNONABILIT__EST}>
                    {collapseOpenTITNONABILIT__EST && (
                      <>
                        <DichiarazioneTitoloEstero
                          ref={_formRefTitle3["TITNONABILIT__EST"]}
                          competitionClass={competitionClass}
                          payloadTitle={this.state.payloadCurrentTitles}
                          defaultPayload={defaultValues.TITNONABILIT__EST[0]}
                        />
                      </>
                    )}
                  </AccordionBody>
                </>
              )}
            </Accordion>
          </Col>
        </Row>       
        {competitionClass === "A023" && (
          <>
            <hr />
            <Row>
              <Col>
                <h6>
                  3.1 REQUISITO AGGIUNTIVO E OBBLIGATORIO (DM 92/16 E SUCCESSIVE MODIFICHE E INTEGRAZIONI) - TITOLO DI SPECIALIZZAZIONE IN ITALIANO L2
                </h6>
                <FormTitleL2
                  ref={_formRefTitleL2}
                  qualificationCode="titleL2"
                  template="SpecializzazioneL2"
                  defaultPayload={defaultValues?.SpecializzazioneL2?.[0]}
                />
              </Col>
            </Row>
          </>
        )}
         <hr />
        <Row className="mt-2">
          <Col>
            <h6>
              4. ULTERIORI DICHIARAZIONI PER LA CLASSE DI CONCORSO {competitionClass} {" "}
            </h6>
            <DichiarazioniUlteriori
              ref={_formRefOther}
              competitionClass={competitionClass}
              defaultPayload={{
                laurea: defaultValues.CLaurea,
                diploma: defaultValues.CDiploma,
                cfu: defaultValues.CCFU,
                insegnamenti: defaultValues.InsegnamentoMultiManager,
              }}
            />
          </Col>
        </Row>
        <Row>
          <div className="w-100">
            {validationSummary && (
              <div className="alert alert-danger mt-3" role="alert">
                {ReactHtmlParser(validationSummary)}
              </div>
            )}
          </div>
        </Row>
      </>
    );
  }
}
